import { showErrorMessage } from 'actions/messages';
import { tutorialsApi } from 'services/api/tutorials-api';
import { TUTORIALS_LOAD_SUCCESS } from './action-types';

export function loadTutorialsRequest() {
  return (dispatch) => {
    return tutorialsApi.getTutorials().then((response) => {
      if (response.ok) {
        dispatch(loadTutorialsSuccess(response.tutorials));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function loadTutorialsSuccess(tutorials) {
  return {
    type: TUTORIALS_LOAD_SUCCESS,
    payload: tutorials,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/tutorials/store/actions.js